import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Users from "../components/Users";
import RowList from "../components/RowList";
import RowList1 from "../components/RowList1";
import RowList2 from "../components/RowList2";
import RowList3 from "../components/RowList3";
import RowList13 from "../components/RowList13";
import RowList4 from "../components/RowList4";
import RowList5 from "../components/RowList5";
import RowList6 from "../components/RowList6";
import RowList7 from "../components/RowList7";
import RowList8 from "../components/RowList8";
import Profile from "../components/Profile";
import Security1 from "../components/Security1";
import Actions from "../components/Actions";
import Referrals from "../components/Referrals";
import Balances from "../components/Balances";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWrench, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { Toaster, toast } from 'react-hot-toast';
import Modal from 'react-modal';
import MiniTradeForm2 from "../components/MiniTradeForm2";

function Manage() {
  const { user } = useUser();
  //TRACK CURRENT USER
  const [selectedUser, setSelectedUser] = useState(null);
  const [userTab, setUserTab] = useState('profile');

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [manageTab, setManageTab] = useState("users");

  const [deposithistorys, setDeposithistorys] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All" },
    { value: "success", label: "Success" },
    { value: "pending", label: "Pending" },
    { value: "failed", label: "failed" },
  ];
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const applyWalletBalance = (list) =>
      list.map(item => {
        return {
          ...item
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
      ...applyWalletBalance(fiat),
      ...applyWalletBalance(stock)
    ];
    const sorted = merged.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchdeposit1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
            const coinName = tx.method.split(" - ")[0];
            const coin = assethistory.find(c => c.name == coinName);
            return {
            ...tx,
            logo: coin ? coin.logo : null,
            symbol: coin ? coin.symbol : null
            };
        });
        setDeposithistorys(updatedTrans);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  const filteredHistory = deposithistorys.filter(deposithistory => 
    Object.values(deposithistory).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) && 
    (selectedFilter === 'all' || deposithistory.status.toLowerCase() === selectedFilter.toLowerCase())
  )

  //VERIFICATION CODE
  const [verificationList, setVerificationList] = useState([]);
  const [searchTerm1, setSearchTerm1] = useState('');
  const [selectedFilter1, setSelectedFilter1] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchcverification: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setVerificationList(data.verify);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  const filteroptions1 = [
    { value: "all", label: "All" },
    { value: "1", label: "Approved" },
    { value: "0", label: "Pending" },
  ];
  const filteredVerify = verificationList.filter(verificationList => 
    Object.values(verificationList).some(value => 
        value.toString().toLowerCase().includes(searchTerm1.toLowerCase())
    ) && 
    (selectedFilter === 'all' || verificationList.status.toLowerCase() === selectedFilter.toLowerCase())
  )

  //WITHDRAWAL CODE
  const [withdrawList, setWithdrawList] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState('');
  const [selectedFilter2, setSelectedFilter2] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwithdraw: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          if (
            coinName === "Bank Transfer" ||
            coinName === "Paypal" ||
            coinName === "Skrill"
          ) {
            logo = `/uploads/usd.svg`;
            symbol = "USD";
          } else {
            const asset = assethistory.find(asset => asset.name === coinName);
            if (asset) {
              logo = asset.logo;
              symbol = asset.symbol;
            }
          }
          return {
            ...tx,
            logo,
            symbol
          };
        });
        setWithdrawList(updatedTrans);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  const filteredWith = withdrawList.filter(withdrawList => 
    Object.values(withdrawList).some(value => 
        value.toString().toLowerCase().includes(searchTerm2.toLowerCase())
    ) && 
    (selectedFilter2 === 'all' || withdrawList.status.toLowerCase() === selectedFilter2.toLowerCase())
  )

  //TRADE CODE
  const [expertTrades, setExpertTrades] = useState([]);
  const [tradeList, setTradeList] = useState([]);
  const [searchTerm3, setSearchTerm3] = useState('');
  const [selectedFilter3, setSelectedFilter3] = useState('all');
  const [searchTerm13, setSearchTerm13] = useState('');
  const [selectedFilter13, setSelectedFilter13] = useState('all');
  const filteroptions2 = [
    { value: "all", label: "All" },
    { value: "position", label: "Position" },
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
  ];
  const filteroptions12 = [
    { value: "all", label: "All" },
    { value: "position", label: "Position" },
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
  ];
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchftrade1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrades = data.trades.map(trade => {
          const symbol = trade.pair.includes('/') 
            ? trade.pair.split('/')[0] 
            : trade.pair;
          const asset = assethistory.find(asset => asset.symbol === symbol);
          let logo;
          if (asset) {
            logo = asset.logo;
          } else {
            logo = `/uploads/usd.svg`;
          }
          return {
            ...trade,
            symbol,
            logo
          };
        });
        setTradeList(updatedTrades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  const filteredTrades = tradeList.filter(tradeList => 
    Object.values(tradeList).some(value => 
        value.toString().toLowerCase().includes(searchTerm3.toLowerCase())
    ) && 
    (selectedFilter3 === 'all' || tradeList.status.toLowerCase() === selectedFilter3.toLowerCase())
  )
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchfexperttrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrades = data.trades.map(trade => {
          const symbol = trade.pair.includes('/') 
            ? trade.pair.split('/')[0] 
            : trade.pair;
          const asset = assethistory.find(asset => asset.symbol === symbol);
          let logo;
          if (asset) {
            logo = asset.logo;
          } else {
            logo = `/uploads/usd.svg`;
          }
          return {
            ...trade,
            symbol,
            logo
          };
        });
        setExpertTrades(updatedTrades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  const filteredExpertTrades = expertTrades.filter(tradeList => 
    Object.values(tradeList).some(value => 
        value.toString().toLowerCase().includes(searchTerm13.toLowerCase())
    ) && 
    (selectedFilter13 === 'all' || tradeList.status.toLowerCase() === selectedFilter13.toLowerCase())
  )

  //SIGNAL CODE
  const [signalList, setSignalList] = useState([]);
  const [searchTerm4, setSearchTerm4] = useState('');
  const [selectedFilter4, setSelectedFilter4] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsignal1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSignalList(data.signal);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const filteroptions3 = [
    { value: "all", label: "All" },
  ];
  const filteredSignal = signalList.filter(signalList => 
    Object.values(signalList).some(value => 
        value.toString().toLowerCase().includes(searchTerm4.toLowerCase())
    ) && 
    (selectedFilter4 === 'all' || signalList.status.toLowerCase() === selectedFilter4.toLowerCase())
  )

  //SUBSCRIPTION CODE
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [searchTerm5, setSearchTerm5] = useState('');
  const [selectedFilter5, setSelectedFilter5] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsubscription1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSubscriptionList(data.subscription);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const filteroptions4 = [
    { value: "all", label: "All" },
  ];
  const filteredSubscription = subscriptionList.filter(subscriptionList => 
    Object.values(subscriptionList).some(value => 
        value.toString().toLowerCase().includes(searchTerm5.toLowerCase())
    ) && 
    (selectedFilter5 === 'all' || subscriptionList.status.toLowerCase() === selectedFilter5.toLowerCase())
  )

  //COPY TRADE CODE
  const [copyList, setCopyList] = useState([]);
  const [searchTerm6, setSearchTerm6] = useState('');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchcopytrade1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setCopyList(data.copy);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const filteredCopy = copyList.filter(copyList => 
    Object.values(copyList).some(value => 
        value.toString().toLowerCase().includes(searchTerm6.toLowerCase())
    )
  )

  //STAKING CODE
  const [stakeList, setStakeList] = useState([]);
  const [searchTerm7, setSearchTerm7] = useState('');
  const [selectedFilter7, setSelectedFilter7] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchstakes1: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStakeList(data.stakes);
      }
    })
    .catch(err => { 
    })
  }, [user]);
  const filteroptions6 = [
    { value: "all", label: "All" },
    { value: "1", label: "Open" },
    { value: "0", label: "Closed" },
  ];
  const filteredStake = stakeList.filter(stakeList => 
    Object.values(stakeList).some(value => 
        value.toString().toLowerCase().includes(searchTerm7.toLowerCase())
    ) && 
    (selectedFilter7 === 'all' || stakeList.status == selectedFilter7.toLowerCase())
  )

  //STOCK CODE
  const [stockList, setStockList] = useState([]);
  const [searchTerm9, setSearchTerm9] = useState('');
  const [selectedFilter9, setSelectedFilter9] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchstock: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStockList(data.stocks);
      }
    })
    .catch(err => { 
    })
  }, [user]);
  const filteroptions8 = [
    { value: "all", label: "All" },
    { value: "active", label: "Active" },
    { value: "closed", label: "Closed" },
  ];
  const filteredStock = stockList.filter(stockList => 
    Object.values(stockList).some(value => 
        value.toString().toLowerCase().includes(searchTerm9.toLowerCase())
    ) && 
    (selectedFilter9 === 'all' || stockList.status == selectedFilter9.toLowerCase())
  )

  //USERS CODE
  const [usersList, setUsersList] = useState([]);
  const [searchTerm8, setSearchTerm8] = useState('');
  const [selectedFilter8, setSelectedFilter8] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchusers: true })
    }) 
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setUsersList(data.users);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const filteroptions7 = [
    { value: "all", label: "All" },
    { value: "active", label: "Active" },
    { value: "blocked", label: "Blocked" },
    { value: "verified", label: "Verified" },
    { value: "unverified", label: "Unverified" },
  ];
  const filteredUsers = usersList.filter(user => {
    const matchesSearch = Object.values(user).some(value =>
      value.toString().toLowerCase().includes(searchTerm8.toLowerCase())
    );
    if (!matchesSearch) return false;
    if (selectedFilter8 === "all") return true;
    switch (selectedFilter8) {
      case "active":
        return user.deleted === 0 || user.deleted === "0";
      case "blocked":
        return user.deleted === 1 || user.deleted === "1";
      case "verified":
        return user.verify === 1 || user.verify === "1";
      case "unverified":
        return user.verify === 0 || user.verify === "0";
      default:
        return true;
    }
  });

  ////////USER CODE///////
  ////////USER CODE///////
  ////////USER CODE///////
 ////////USER CODE///////  
 // ////////USER CODE///////
  ////////USER CODE///////
  ////////USER CODE///////
 ////////USER CODE///////
  ////////USER CODE///////
  ////////USER CODE///////
  ////////USER CODE///////
 ////////USER CODE///////

  const [deposithistorysu, setDeposithistorysu] = useState([]);
  const [searchTermu, setSearchTermu] = useState('');
  const [selectedFilteru, setSelectedFilteru] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchdeposit2: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
            const coinName = tx.method.split(" - ")[0];
            const coin = assethistory.find(c => c.name == coinName);
            return {
            ...tx,
            logo: coin ? coin.logo : null,
            symbol: coin ? coin.symbol : null
            };
        });
        setDeposithistorysu(updatedTrans);
      }
    })
    .catch(err => {
      
    })
  }, [user, assethistory, selectedUser]);
  const filteredHistoryu = deposithistorysu.filter(deposithistoryu => 
    Object.values(deposithistoryu).some(value => 
        value.toString().toLowerCase().includes(searchTermu.toLowerCase())
    ) && 
    (selectedFilteru === 'all' || deposithistoryu.status.toLowerCase() === selectedFilteru.toLowerCase())
  )

  //VERIFICATION CODE
  const [verificationListu, setVerificationListu] = useState([]);
  const [searchTerm1u, setSearchTerm1u] = useState('');
  const [selectedFilter1u, setSelectedFilter1u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchcverification1: true, email: (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setVerificationListu(data.verify);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory, selectedUser]);
  const filteredVerifyu = verificationListu.filter(verificationListu => 
    Object.values(verificationListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm1u.toLowerCase())
    ) && 
    (selectedFilteru === 'all' || verificationListu.status.toLowerCase() === selectedFilteru.toLowerCase())
  )

  //WITHDRAWAL CODE
  const [withdrawListu, setWithdrawListu] = useState([]);
  const [searchTerm2u, setSearchTerm2u] = useState('');
  const [selectedFilter2u, setSelectedFilter2u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwithdraw1: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedTrans = data.trans.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          if (
            coinName === "Bank Transfer" ||
            coinName === "Paypal" ||
            coinName === "Skrill"
          ) {
            logo = `/uploads/usd.svg`;
            symbol = "USD";
          } else {
            const asset = assethistory.find(asset => asset.name === coinName);
            if (asset) {
              logo = asset.logo;
              symbol = asset.symbol;
            }
          }
          return {
            ...tx,
            logo,
            symbol
          };
        });
        setWithdrawListu(updatedTrans);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory, selectedUser]);
  const filteredWithu = withdrawListu.filter(withdrawListu => 
    Object.values(withdrawListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm2u.toLowerCase())
    ) && 
    (selectedFilter2u === 'all' || withdrawListu.status.toLowerCase() === selectedFilter2u.toLowerCase())
  )

  //SIGNAL CODE
  const [signalListu, setSignalListu] = useState([]);
  const [searchTerm4u, setSearchTerm4u] = useState('');
  const [selectedFilter4u, setSelectedFilter4u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsignal2: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSignalListu(data.signal);
      }
    })
    .catch(err => {
    })
  }, [user, selectedUser]);
  const filteredSignalu = signalListu.filter(signalListu => 
    Object.values(signalListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm4u.toLowerCase())
    ) && 
    (selectedFilter4u === 'all' || signalListu.status.toLowerCase() === selectedFilter4u.toLowerCase())
  )

  //SUBSCRIPTION CODE
  const [subscriptionListu, setSubscriptionListu] = useState([]);
  const [searchTerm5u, setSearchTerm5u] = useState('');
  const [selectedFilter5u, setSelectedFilter5u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsubscription2: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setSubscriptionListu(data.subscription);
      }
    })
    .catch(err => {
    })
  }, [user, selectedUser]);
  const filteredSubscriptionu = subscriptionListu.filter(subscriptionListu => 
    Object.values(subscriptionListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm5u.toLowerCase())
    ) && 
    (selectedFilter5u === 'all' || subscriptionListu.status.toLowerCase() === selectedFilter5u.toLowerCase())
  )

  //COPY TRADE CODE
  const [copyListu, setCopyListu] = useState([]);
  const [searchTerm6u, setSearchTerm6u] = useState('');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchcopytrade2: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setCopyListu(data.copy);
      }
    })
    .catch(err => {
    })
  }, [user, selectedUser]);
  const filteredCopyu = copyListu.filter(copyListu => 
    Object.values(copyListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm6u.toLowerCase())
    )
  )

  //STAKING CODE
  const [stakeListu, setStakeListu] = useState([]);
  const [searchTerm7u, setSearchTerm7u] = useState('');
  const [selectedFilter7u, setSelectedFilter7u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchstakes2: true, email : (selectedUser)?selectedUser.email:'' })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStakeListu(data.stakes);
      }
    })
    .catch(err => { 

    })
  }, [user, selectedUser]);
  const filteredStakeu = stakeListu.filter(stakeListu => 
    Object.values(stakeListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm7u.toLowerCase())
    ) && 
    (selectedFilter7u === 'all' || stakeListu.status == selectedFilter7u.toLowerCase())
  )

    //STOCK CODE
  const [stockListu, setStockListu] = useState([]);
  const [searchTerm9u, setSearchTerm9u] = useState('');
  const [selectedFilter9u, setSelectedFilter9u] = useState('all');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchstock: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setStockListu(data.stocks);
      }
    })
    .catch(err => { 
    })
  }, [user]);
  const filteredStocku = stockListu.filter(stockListu => 
    Object.values(stockListu).some(value => 
        value.toString().toLowerCase().includes(searchTerm9u.toLowerCase())
    ) && 
    (selectedFilter9u === 'all' || stockListu.status == selectedFilter9u.toLowerCase())
  )

  const [profileTab, setProfileTab] = useState('profile');
  const [modalIsOpen15, setIsOpen15] = useState(false);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Manage" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Manage" icon={<FontAwesomeIcon icon={faWrench} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
                <div className="col-12">
                    <div className="mycard mt-2" style={{minHeight: '88vh'}}>
                        <div className="d-flex align-items-cemter mt-2 overflow-x-auto" style={{cursor:'pointer'}}>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "users" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "users" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setManageTab("users"); setSelectedUser(null);}}>Users</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "payments" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "payments" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("payments")}>Payments</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "verifications" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "verifications" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("verifications")}>Verifications</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "withdrawals" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "withdrawals" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("withdrawals")}>Withdrawals</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "trades" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "trades" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("trades")}>Trades</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3 text-nowrap" style={{color: manageTab === "experts" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "experts" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("experts")}>Expert Trades</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "signals" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "signals" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("signals")}>Signals</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "subscriptions" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "subscriptions" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("subscriptions")}>Subscriptions</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3 text-nowrap" style={{color: manageTab === "copytrading" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "copytrading" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("copytrading")}>Copy Trading</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "stakings" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "stakings" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("stakings")}>Stakings</h6>
                            <h6 className="mb-0 fw-bold py-3 me-3" style={{color: manageTab === "stocks" ? 'white' : 'gray', fontSize: '18px', borderBottom: manageTab === "stocks" ? '2px solid #ff6b35' : 'none'}} onClick={() => setManageTab("stocks")}>Stocks</h6>
                        </div>
                        <hr className="mb-4" style={{marginTop: '0px',opacity:'0.05'}}/>
                        {manageTab === "users" && (
                          <>
                          {!selectedUser ? (
                            <>
                            <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Users</h6>
                                <div className="d-flex align-items-center mt-2 mt-lg-0">
                                    <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                        <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                        <input 
                                        type="text" 
                                        placeholder="Search for a user" 
                                        className="searchinput"
                                        value={searchTerm8} onChange={(e) => setSearchTerm8(e.target.value)}
                                        />
                                    </div>
                                    <Select 
                                        options={filteroptions7}
                                        value={filteroptions7.find((opt) => opt.value === selectedFilter8)}
                                        onChange={(e) => setSelectedFilter8(e.value)}
                                        styles={darkThemeStyles}
                                        className="w-full"
                                    />
                                </div>
                            </div>
                            <div className="mobile-table-responsive">
                              <table className="table table-striped table-borderless table-hover table-dark align-middle">
                                  <thead>
                                      <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Username</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Currency</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Country</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Address</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Registered</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Verification</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                      </tr>
                                  </thead>
                                  <tbody style={{fontSize: '14px'}}>
                                    {filteredUsers.length > 0 ? (
                                        filteredUsers.map((user) => (
                                          <Users key={user.id} data={user} onSelectUser={setSelectedUser} />
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={8}>You have no user</td>
                                      </tr>
                                    )}
                                  </tbody>
                              </table>
                            </div>
                            </>
                          ) : (
                            <>
                              <div className="overflow-x-auto d-inline-block" style={{maxWidth:'100%'}}>
                                <div className="blockTab">
                                  <div className={`blockTab-item text-nowrap ${userTab === "profile" ? 'active' : ''}`} onClick={() => {setUserTab("profile")}}>Profile</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "payments" ? 'active' : ''}`} onClick={() => {setUserTab("payments")}}>Payments</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "verifications" ? 'active' : ''}`} onClick={() => {setUserTab("verifications")}}>Verifications</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "withdrawals" ? 'active' : ''}`} onClick={() => {setUserTab("withdrawals")}}>Withdrawals</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "signals" ? 'active' : ''}`} onClick={() => {setUserTab("signals")}}>Signals</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "subscriptions" ? 'active' : ''}`} onClick={() => {setUserTab("subscriptions")}}>Subscriptions</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "copytrading" ? 'active' : ''}`} onClick={() => {setUserTab("copytrading")}}>Copy Trading</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "stakings" ? 'active' : ''}`} onClick={() => {setUserTab("stakings")}}>Stakings</div>
                                  <div className={`blockTab-item text-nowrap ${userTab === "stocks" ? 'active' : ''}`} onClick={() => {setUserTab("stocks")}}>Stocks</div>
                                </div>
                              </div>
                              {userTab === "profile" && (
                                <div className="row">
                                  <div className="col-lg-2 g-5">
                                    <div className="d-flex flex-column" style={{cursor:'pointer'}}>
                                      <div className="rounded-2 fw-bold lh-1" onClick={() => setProfileTab('profile')} style={{backgroundColor: profileTab === "profile" ? 'rgba(255,255,255,0.094)' : null, padding: '12px'}}>
                                        <span>Profile</span>
                                      </div>
                                      <div className="rounded-2 fw-bold lh-1" onClick={() => setProfileTab('security')} style={{backgroundColor: profileTab === "security" ? 'rgba(255,255,255,0.094)' : null, padding: '12px'}}>
                                        <span>Security</span>
                                      </div>
                                      <div className="rounded-2 fw-bold lh-1" onClick={() => setProfileTab('actions')} style={{backgroundColor: profileTab === "actions" ? 'rgba(255,255,255,0.094)' : null, padding: '12px'}}>
                                        <span>Actions</span>
                                      </div>
                                      <div className="rounded-2 fw-bold lh-1" onClick={() => setProfileTab('balances')} style={{backgroundColor: profileTab === "balances" ? 'rgba(255,255,255,0.094)' : null, padding: '12px'}}>
                                        <span>Balances</span>
                                      </div>
                                      <div className="rounded-2 fw-bold lh-1" onClick={() => setProfileTab('referrals')} style={{backgroundColor: profileTab === "referrals" ? 'rgba(255,255,255,0.094)' : null, padding: '12px'}}>
                                        <span>Referrals</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-xxl-5 col-lg-6 col-12 g-5">
                                    {profileTab === "profile" && (
                                        <Profile selectedUser={selectedUser}/>
                                    )}
                                    {profileTab === "security" && (
                                        <Security1 selectedUser={selectedUser}/>
                                    )}
                                    {profileTab === "actions" && (
                                        <Actions selectedUser={selectedUser}/>
                                    )}
                                    {profileTab === "balances" && (
                                        <Balances selectedUser={selectedUser}/>
                                    )}
                                    {profileTab === "referrals" && (
                                        <Referrals selectedUser={selectedUser}/>
                                    )}
                                  </div>
                                </div>
                              )}
                              {userTab === "payments" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Payments</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for deposits" 
                                          className="searchinput"
                                          value={searchTermu} onChange={(e) => setSearchTermu(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions}
                                          value={filteroptions.find((opt) => opt.value === selectedFilteru)}
                                          onChange={(e) => setSelectedFilteru(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                  <table className="table table-borderless table-dark align-middle">
                                      <thead>
                                          <tr className="fs-7">
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                          <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                          </tr>
                                      </thead>
                                      <tbody style={{fontSize: '14px'}}>
                                      {filteredHistoryu.length > 0 ? (
                                          filteredHistoryu.map((history) => (
                                              <RowList data={history}/>
                                          ))
                                      ) : (
                                          <tr>
                                              <td className="py-5" colSpan={7}>You have not received any deposits yet</td>
                                          </tr>
                                      )}
                                      </tbody>
                                  </table>
                              </div>
                              </>
                              )}
                              {userTab === "verifications" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Verifications</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for request" 
                                          className="searchinput"
                                          value={searchTerm1u} onChange={(e) => setSearchTerm1u(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions1}
                                          value={filteroptions1.find((opt) => opt.value === selectedFilter1u)}
                                          onChange={(e) => setSelectedFilter1u(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredVerifyu.length > 0 ? (
                                        filteredVerifyu.map((verify) => (
                                            <RowList1 data={verify}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received any verification request</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                              {userTab === "withdrawals" && (
                                <>
                                <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                    <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Withdrawals</h6>
                                    <div className="d-flex align-items-center mt-2 mt-lg-0">
                                        <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                            <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                            <input 
                                            type="text" 
                                            placeholder="Search for withdraws" 
                                            className="searchinput"
                                            value={searchTerm2u} onChange={(e) => setSearchTerm2u(e.target.value)}
                                            />
                                        </div>
                                        <Select 
                                            options={filteroptions}
                                            value={filteroptions.find((opt) => opt.value === selectedFilter2u)}
                                            onChange={(e) => setSelectedFilter2u(e.value)}
                                            styles={darkThemeStyles}
                                            className="w-full"
                                        />
                                    </div>
                                </div>
                                <div className="mobile-table-responsive">
                                    <table className="table table-borderless table-dark align-middle">
                                        <thead>
                                            <tr className="fs-7">
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                            <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{fontSize: '14px'}}>
                                        {filteredWithu.length > 0 ? (
                                            filteredWithu.map((history) => (
                                                <RowList2 data={history}/>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="py-5" colSpan={7}>You have not received any withdrawal yet</td>
                                            </tr>
                                        )}
                                        </tbody>
                                    </table>
                                </div>
                                </>
                              )}
                              {userTab === "signals" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Signals</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for signals" 
                                          className="searchinput"
                                          value={searchTerm4u} onChange={(e) => setSearchTerm4u(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions3}
                                          value={filteroptions3.find((opt) => opt.value === selectedFilter4u)}
                                          onChange={(e) => setSelectedFilter4u(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Signal</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Price</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Strength</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredSignalu.length > 0 ? (
                                        filteredSignalu.map((signals) => (
                                            <RowList4 data={signals}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received signal purchase</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                              {userTab === "subscriptions" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Subscriptions</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for subscriptions" 
                                          className="searchinput"
                                          value={searchTerm5u} onChange={(e) => setSearchTerm5u(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions4}
                                          value={filteroptions4.find((opt) => opt.value === selectedFilter5u)}
                                          onChange={(e) => setSelectedFilter5u(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Plan</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Duration</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredSubscriptionu.length > 0 ? (
                                        filteredSubscriptionu.map((subscription) => (
                                            <RowList5 data={subscription}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received subscription purchase</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                              {userTab === "copytrading" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Copy trading</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text"
                                          placeholder="Search for experts for user" 
                                          className="searchinput"
                                          value={searchTerm6u} onChange={(e) => setSearchTerm6u(e.target.value)}
                                          />
                                      </div>
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Expert</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredCopyu.length > 0 ? (
                                        filteredCopyu.map((copy) => (
                                            <RowList6 data={copy}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received copytrade purchase</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                              {userTab === "stakings" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Stakings</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for stakings" 
                                          className="searchinput"
                                          value={searchTerm7u} onChange={(e) => setSearchTerm7u(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions6}
                                          value={filteroptions6.find((opt) => opt.value === selectedFilter7u)}
                                          onChange={(e) => setSelectedFilter7u(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Duration</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI</th>
                                        {/* <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI USD</th> */}
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredStakeu.length > 0 ? (
                                        filteredStakeu.map((staking) => (
                                            <RowList7 data={staking}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received staking plan</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                              {userTab === "stocks" && (
                              <>
                              <div className="d-lg-flex align-items-center justify-content-between mb-4">
                                  <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Stocks</h6>
                                  <div className="d-flex align-items-center mt-2 mt-lg-0">
                                      <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                          <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                          <input 
                                          type="text" 
                                          placeholder="Search for stakings" 
                                          className="searchinput"
                                          value={searchTerm9u} onChange={(e) => setSearchTerm9u(e.target.value)}
                                          />
                                      </div>
                                      <Select 
                                          options={filteroptions8}
                                          value={filteroptions8.find((opt) => opt.value === selectedFilter9u)}
                                          onChange={(e) => setSelectedFilter9u(e.value)}
                                          styles={darkThemeStyles}
                                          className="w-full"
                                      />
                                  </div>
                              </div>
                              <div className="mobile-table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                       <tr className="fs-7">
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Stock Name</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Symbol</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Pur. Price</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount USD</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                        <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {filteredStocku.length > 0 ? (
                                        filteredStocku.map((staking) => (
                                            <RowList8 data={staking}/>
                                        ))
                                    ) : (
                                      <tr>
                                        <td className="py-5" colSpan={7}>You have not received any stock</td>
                                      </tr>
                                    )}
                                    </tbody>
                                </table>
                              </div>
                              </>
                              )}
                            </>
                          )}
                          </>
                        )}
                        {manageTab === "payments" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Payments</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for deposits" 
                                    className="searchinput"
                                    value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions}
                                    value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                    onChange={(e) => setSelectedFilter(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                {filteredHistory.length > 0 ? (
                                    filteredHistory.map((history) => (
                                        <RowList data={history}/>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="py-5" colSpan={7}>You have not received any deposits yet</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                        </>
                        )}
                        {manageTab === "verifications" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Verifications</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for request" 
                                    className="searchinput"
                                    value={searchTerm1} onChange={(e) => setSearchTerm1(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions1}
                                    value={filteroptions1.find((opt) => opt.value === selectedFilter1)}
                                    onChange={(e) => setSelectedFilter1(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredVerify.length > 0 ? (
                                  filteredVerify.map((verify) => (
                                      <RowList1 data={verify}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received any verification request</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                        {manageTab === "withdrawals" && (
                          <>
                          <div className="d-lg-flex align-items-center justify-content-between mb-4">
                              <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Withdrawals</h6>
                              <div className="d-flex align-items-center mt-2 mt-lg-0">
                                  <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                      <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                      <input 
                                      type="text" 
                                      placeholder="Search for withdraws" 
                                      className="searchinput"
                                      value={searchTerm2} onChange={(e) => setSearchTerm2(e.target.value)}
                                      />
                                  </div>
                                  <Select 
                                      options={filteroptions}
                                      value={filteroptions.find((opt) => opt.value === selectedFilter2)}
                                      onChange={(e) => setSelectedFilter2(e.value)}
                                      styles={darkThemeStyles}
                                      className="w-full"
                                  />
                              </div>
                          </div>
                          <div className="mobile-table-responsive">
                              <table className="table table-borderless table-dark align-middle">
                                  <thead>
                                      <tr className="fs-7">
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody style={{fontSize: '14px'}}>
                                  {filteredWith.length > 0 ? (
                                      filteredWith.map((history) => (
                                          <RowList2 data={history}/>
                                      ))
                                  ) : (
                                      <tr>
                                          <td className="py-5" colSpan={7}>You have not received any withdrawal yet</td>
                                      </tr>
                                  )}
                                  </tbody>
                              </table>
                          </div>
                          </>
                        )}
                        {manageTab === "trades" && (
                          <>
                          <div className="d-lg-flex align-items-center justify-content-between mb-4">
                              <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Trades</h6>
                              <div className="d-flex align-items-center mt-2 mt-lg-0">
                                  <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                      <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                      <input 
                                      type="text" 
                                      placeholder="Search for trades" 
                                      className="searchinput"
                                      value={searchTerm3} 
                                      onChange={(e) => setSearchTerm3(e.target.value)}
                                      />
                                  </div>
                                  <Select 
                                      options={filteroptions2}
                                      value={filteroptions2.find((opt) => opt.value === selectedFilter3)}
                                      onChange={(e) => setSelectedFilter3(e.value)}
                                      styles={darkThemeStyles}
                                      className="w-full"
                                  />
                              </div>
                          </div>
                          <div className="mobile-table-responsive">
                              <table className="table table-borderless table-dark align-middle">
                                  <thead>
                                      <tr className="fs-7">
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Trade</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Leverage</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Direction</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Pattern</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Profit</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody style={{fontSize: '14px'}}>
                                  {filteredTrades.length > 0 ? (
                                      filteredTrades.map((history) => (
                                          <RowList3 data={history}/>
                                      ))
                                  ) : (
                                      <tr>
                                          <td className="py-5" colSpan={7}>You have not received any trades yet</td>
                                      </tr>
                                  )}
                                  </tbody>
                              </table>
                          </div>
                          </>
                        )}
                        {manageTab === "experts" && (
                          <>
                          <div className="d-lg-flex align-items-center justify-content-between mb-4">
                              <div className="d-flex align-items-center" style={{gap:'20px'}}>
                                <h6 className="mb-0 text-light fw-bold text-nowrap" style={{fontSize: '18px'}}>Expert Trades</h6>
                                <div onClick={() => setIsOpen15(true)} className="py-1 px-2 rounded-pill" style={{border: '2px solid #ff6b35',backgroundColor:'transparent', textDecoration:'none',cursor:'pointer'}}>
                                  <p className="mb-0 fw-semibold text-prime" style={{fontSize: '14px'}}>Add Trade</p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center mt-2 mt-lg-0">
                                  <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                      <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                      <input 
                                      type="text" 
                                      placeholder="Search for trades" 
                                      className="searchinput"
                                      value={searchTerm13} 
                                      onChange={(e) => setSearchTerm13(e.target.value)}
                                      />
                                  </div>
                                  <Select 
                                      options={filteroptions12}
                                      value={filteroptions12.find((opt) => opt.value === selectedFilter13)}
                                      onChange={(e) => setSelectedFilter13(e.value)}
                                      styles={darkThemeStyles}
                                      className="w-full"
                                  />
                              </div>
                          </div>
                          <div className="mobile-table-responsive">
                              <table className="table table-borderless table-dark align-middle">
                                  <thead>
                                      <tr className="fs-7">
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Copy Trader</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Trade</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Type</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Leverage</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Direction</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Pattern</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Profit</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                      <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                      </tr>
                                  </thead>
                                  <tbody style={{fontSize: '14px'}}>
                                  {filteredExpertTrades.length > 0 ? (
                                      filteredExpertTrades.map((history) => (
                                          <RowList13 data={history}/>
                                      ))
                                  ) : (
                                      <tr>
                                          <td className="py-5" colSpan={7}>You have not received any trades from experts yet</td>
                                      </tr>
                                  )}
                                  </tbody>
                              </table>
                          </div>
                          <Modal
                              isOpen={modalIsOpen15}
                              onRequestClose={() => setIsOpen15(false)}
                              shouldCloseOnOverlayClick={true} 
                              closeTimeoutMS={100}
                              className="shortmode"
                          >
                              <div className="d-flex align-items-center justify-content-between">
                                  <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Fix a trade</p>
                                  <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen15(false)} />
                              </div>
                              {modalIsOpen15 && <MiniTradeForm2/>}
                          </Modal>
                          </>
                        )}
                        {manageTab === "signals" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Signals</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for signals" 
                                    className="searchinput"
                                    value={searchTerm4} onChange={(e) => setSearchTerm4(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions3}
                                    value={filteroptions3.find((opt) => opt.value === selectedFilter4)}
                                    onChange={(e) => setSelectedFilter4(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Signal</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Price</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Strength</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredSignal.length > 0 ? (
                                  filteredSignal.map((signals) => (
                                      <RowList4 data={signals}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received signal purchase</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                        {manageTab === "subscriptions" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Subscriptions</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for subscriptions" 
                                    className="searchinput"
                                    value={searchTerm5} onChange={(e) => setSearchTerm5(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions4}
                                    value={filteroptions4.find((opt) => opt.value === selectedFilter5)}
                                    onChange={(e) => setSelectedFilter5(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Plan</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Duration</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredSubscription.length > 0 ? (
                                  filteredSubscription.map((subscription) => (
                                      <RowList5 data={subscription}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received subscription purchase</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                        {manageTab === "copytrading" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Copy trading</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text"
                                    placeholder="Search for experts for user" 
                                    className="searchinput"
                                    value={searchTerm6} onChange={(e) => setSearchTerm6(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Expert</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredCopy.length > 0 ? (
                                  filteredCopy.map((copy) => (
                                      <RowList6 data={copy}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received copytrade purchase</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                        {manageTab === "stakings" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Stakings</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for stakings" 
                                    className="searchinput"
                                    value={searchTerm7} onChange={(e) => setSearchTerm7(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions6}
                                    value={filteroptions6.find((opt) => opt.value === selectedFilter7)}
                                    onChange={(e) => setSelectedFilter7(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Duration</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI</th>
                                  {/* <th className="fw-normal text-light" style={{fontSize: '12px'}}>ROI USD</th> */}
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                  <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredStake.length > 0 ? (
                                  filteredStake.map((staking) => (
                                      <RowList7 data={staking}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received staking plan</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                        {manageTab === "stocks" && (
                        <>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Stocks</h6>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for stakings" 
                                    className="searchinput"
                                    value={searchTerm9} onChange={(e) => setSearchTerm9(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions8}
                                    value={filteroptions8.find((opt) => opt.value === selectedFilter9)}
                                    onChange={(e) => setSelectedFilter9(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="mobile-table-responsive">
                          <table className="table table-borderless table-dark align-middle">
                              <thead>
                                  <tr className="fs-7">
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Reference</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>User</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Stock Name</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Symbol</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Pur. Price</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Amount USD</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Date</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Status</th>
                                    <th className="fw-normal text-light" style={{fontSize: '12px'}}>Action</th>
                                  </tr>
                              </thead>
                              <tbody style={{fontSize: '14px'}}>
                              {filteredStock.length > 0 ? (
                                  filteredStock.map((stocks) => (
                                      <RowList8 data={stocks}/>
                                  ))
                              ) : (
                                <tr>
                                  <td className="py-5" colSpan={7}>You have not received any stock</td>
                                </tr>
                              )}
                              </tbody>
                          </table>
                        </div>
                        </>
                        )}
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}
export default Manage